<template>
    <div class="time-inputs">
        <SrInput
            v-model.number="hour"
            v-bind="$attrs"
            type="number"
            label="hh"
            min="0"
            max="23"
            hide-details
            @input="validateTimeInput($event, 'hour', { min: 0, max: 23 })"
        />
        <div class="separator" />
        <SrInput
            v-model.number="minute"
            v-bind="$attrs"
            type="number"
            label="mm"
            min="0"
            max="59"
            hide-details
            @input="validateTimeInput($event, 'minute', { min: 0, max: 59 })"
        />
        <div class="separator" />
        <SrInput
            v-model.number="second"
            v-bind="$attrs"
            type="number"
            label="ss"
            min="0"
            max="59"
            hide-details
            @input="validateTimeInput($event, 'second', { min: 0, max: 59 })"
        />
    </div>
</template>

<script>
import SrInput from '../SrInput/SrInput';

export default {
    name: 'TimeInput',
    components: { SrInput },
    model: {
        prop: 'time',
    },
    props: {
        /**
         * @model
         */
        time: {
            type: String,
            default: null,
        },
        /**
         * Defines whether the inputs style should be outlined or not
         */
        outlined: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            hour: null,
            minute: null,
            second: null,
            isTimePickerOpen: false,
        };
    },
    watch: {
        time: 'setTimeFromModel',
        hour: 'emitTimeChange',
        minute: 'emitTimeChange',
        second: 'emitTimeChange',
    },
    created() {
        this.setTimeFromModel();
    },
    methods: {
        setTimeFromModel() {
            if (!this.time) {
                return;
            }

            const regexResult = this.time.match(/(?<hour>\d{2}):(?<minute>\d{2}):(?<second>\d{2})/);
            this.hour = Number(regexResult.groups.hour);
            this.minute = Number(regexResult.groups.minute);
            this.second = Number(regexResult.groups.second);
        },
        emitTimeChange() {
            const normalizedHour = this.normalize(this.hour || 0);
            const normalizedMinute = this.normalize(this.minute || 0);
            const normalizedSecond = this.normalize(this.second || 0);

            const time = `${normalizedHour}:${normalizedMinute}:${normalizedSecond}`;
            this.$emit('input', time);
        },
        normalize(timeUnits) {
            if (String(timeUnits).length === 2) {
                return timeUnits;
            }

            return `0${timeUnits}`;
        },
        /**
         * @param value Number
         * @param property String 'hour' | 'minute' | 'second'
         * @param min Number
         * @param max Number
         */
        validateTimeInput(value, property, { min, max }) {
            if (value < min) {
                this[property] = min;
            }
            if (value > max) {
                this[property] = max;
            }
        },
    },
};
</script>
